<template>
	<v-card>
		<v-card-title class="mt-3">
			<h1 class="ml-2">Kwoty</h1>
		</v-card-title>
		<v-container fluid>
			<ul class="ml-3">
				<li class="mt-2">
					<div>
						<strong style="font-size: 16px;">Kwota wnioskowana:</strong>
						<span v-if="!amounts.requestedDonation"
							class="ml-3" style="font-size: 16px;">brak</span>
						<span v-else
							class="ml-3"
							style="font-size: 16px;">{{formatMoney(amounts.requestedDonation) + " PLN"}}</span>
					</div>
				</li>
				<li class="mt-2">
					<div>
						<strong style="font-size: 16px;">Kwota przyznana:</strong>
						<span v-if="!amounts.summaryDonation"
							class="ml-3" style="font-size: 16px;">brak</span>
						<span v-else
							class="ml-3"
							style="font-size: 16px;">{{formatMoney(amounts.summaryDonation) + " PLN"}}</span>
						<span v-if="hasAccessToEditSummaryDonation()">
							<v-icon style="font-size: 20px" small class="ml-4"
								@click="editSummaryDonation" title="Edytuj">
								edit
							</v-icon>
						</span>
					</div>
				</li>
				<li class="mt-2">
					<div>
						<strong style="font-size: 16px;">Kwota z umowy:</strong>
						<span v-if="!amounts.agreementDonation"
							class="ml-3" style="font-size: 16px;">brak</span>
						<span v-else
							class="ml-3"
							style="font-size: 16px;">{{formatMoney(amounts.agreementDonation) + " PLN"}}</span>
					</div>
				</li>
				<li class="mt-2">
					<div>
						<strong style="font-size: 16px;">Kwota zatwierdzona:</strong>
						<span v-if="!amounts.approvedDonation"
							class="ml-3" style="font-size: 16px;">brak</span>
						<span v-else
							class="ml-3"
							style="font-size: 16px;">{{formatMoney(amounts.approvedDonation) + " PLN"}}</span>
					</div>
				</li>
			</ul>
		</v-container>

		<v-dialog v-model="summaryDonationDialog" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline"> Edycja kwoty przyznanej </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-flex>
							<egranty-number-input-field
								label="Nowa kwota przyznana"
								v-model="editedDonation"
								suffix=" PLN"
								placeholder="np. 100000"
							>
							</egranty-number-input-field>
						</v-flex>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="summaryDonationDialog = false">Anuluj</v-btn>
					<v-btn color="primary" flat @click="saveSummaryDonation">Zapisz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-container fluid>
			<v-layout><h3>Uwagi</h3></v-layout>
			<v-layout>
				<v-flex>
					<v-textarea outline auto-grow v-model="amountsRemarks"
						browser-autocomplete="off" aria-label="amounts remarks"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="saveProjectAmountRemarks">Zapisz</v-btn>
		</v-container>
	</v-card>
</template>

<script>
	import {Project} from "../../../api/generated/Project";
	import EgrantyNumberInputField from "../../../genericComponents/EgrantyNumberInputField";
	import {Numbers} from "../../../utils/Numbers";

	export default {
		name: "ProjectAmountView",
		components: {EgrantyNumberInputField},
		mixins: [Numbers],

		watch: {
			summaryDonationDialog: function (val) {
				if (!val) this.editedDonation = null;
			}
		},

		data () {
			return {
				amounts: {},
				projectStatus: null,
				summaryDonationDialog: false,
				editedDonation: null,
				amountsRemarks: ""
			};
		},

		methods: {
			hasAccessToEditSummaryDonation(){
				return this.projectStatus !== 'WITHDRAWN' && this.$store.state.projectPanelPermissions.hasProjectPanelSupervisorModificationAccess;
			},
			editSummaryDonation() {
				this.editedDonation = this.amounts.summaryDonation;
				this.summaryDonationDialog = true;
			},

			saveSummaryDonation() {
				saveSummaryDonation(this);
			},

			saveProjectAmountRemarks() {
				Project.putAmountRemarks(this, this.$route.params.projectId, {body: this.amountsRemarks});
			},
			getAmountRemarks() {
				Project.getAmountRemarks(this, this.$route.params.projectId, successResponse => {
					this.amountsRemarks = successResponse.remarks;
				});
			}
		},

		created () {
			getProjectStatus(this);
			getProjectAmounts(this);
			this.getAmountRemarks();
		}
	};

	function getProjectStatus (ctx) {
		Project.getStatus(ctx, ctx.$route.params.projectId, successResponse => {
				ctx.projectStatus = successResponse.projectStatus;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować statusu konkursu", errorResponse);
			});
	}

	function getProjectAmounts (ctx) {
		Project.getAmounts(ctx, ctx.$route.params.projectId, successResponse => {
				ctx.amounts = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować kwot", errorResponse);
			});
	}

	function saveSummaryDonation (ctx) {
		Project.putSummaryDonation(ctx, ctx.$route.params.projectId, {body: ctx.editedDonation}, successResponse => {
				ctx.amounts.summaryDonation = ctx.editedDonation;
				ctx.editedDonation = null;
				ctx.summaryDonationDialog = false;
				ctx.$messagesBus.$emit("success", "Kwota została pomyślnie zmieniona", successResponse);
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się zapisać kwoty", errorResponse);
			});
	}
</script>

<style scoped>

</style>
